import { useEffect } from "react";

import { FiltersContainer } from "../../filters/ui/FiltersContainer";
import { SearchInput } from "../../filters/ui/SearchInput";

import { useWebsiteContentAlertsFilterStore } from "./useWebsiteContentAlertsFilterStore";

export const WebsiteContentAlertsFilters = () => {
    const reset = useWebsiteContentAlertsFilterStore((s) => s.reset);
    const searchValue = useWebsiteContentAlertsFilterStore((s) => s.searchValue);
    const setSearchValue = useWebsiteContentAlertsFilterStore((s) => s.setSearchValue);

    useEffect(() => reset, [reset]);

    return (
        <FiltersContainer>
            <SearchInput
                value={searchValue}
                onChange={setSearchValue}
            />
        </FiltersContainer>
    );
};
